import { useParams } from "react-router-dom";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";

import Navigation from "../Components/navigation";
import { HospitalInquiryTable } from "./hospital-inquiry-table";

const HospitalDetailInquiryPage = () => {
  const { id } = useParams();
  return (
    <div>
      <TitlePage title="회원조회 > 회원상세" />
      <Navigation id="inquiry" hospitalId={id} />
      <div className="mt-8">
        <HospitalInquiryTable id={id} />
      </div>
    </div>
  );
};

export default HospitalDetailInquiryPage;
